export const isDevDeploy =
  import.meta.env.DEV || import.meta.env.VITE_DEPLOY_ENV === 'dev'
